// Types
import { State, EntityState, Discount, Track } from 'types'

// Utils
import { TRACK_PRICE } from '@constants'

export const discountSelector = (state: State): EntityState<Discount> => state.entities.discounts

export const discountsMatchingIdSelector = (state: State, ids?: Array<string>): Array<Discount> => {
  if (!ids) {
    return []
  }
  const discounts = discountSelector(state)
  // Filter below is for not displaying discounts for Free songs
  const discountInfo = ids
    .map(id => ({ ...discounts[id], id }))
    .filter(discount => discount.value < 1.99 || discount.type !== 'track')
    .reduce((agg, discount: Discount) => {
      const numberOf = ((agg[discount.id] && agg[discount.id].numberOf) || 0) + 1
      return {
        ...agg,
        [discount.id]: {
          label: discount.type === 'credits' ? `${discount.label} (${numberOf})` : discount.label,
          value: discount.value * numberOf,
          type: discount.type,
          numberOf,
        },
      }
    }, {})
  return Object.keys(discountInfo).map(discountId => discountInfo[discountId])
}

export const getBestTrackDiscount = (state: State, trackId: number): Discount | null | undefined => {
  const discounts = discountSelector(state)
  const discountList = Object.keys(discounts).map(key => discounts[key])
  const activeDiscounts = discountList
    .filter(discount => {
      const isFreeTrack = (discount.type === 'track' && discount.object_id === trackId) || discount.type === 'alltracks'
      return isFreeTrack
    })
    .sort((a, b) => b.value - a.value)
  return activeDiscounts.length ? activeDiscounts[0] : null
}

export const annotateTrackWithPrice = (state: State, track: Track): Track => {
  if (!track) {
    return track
  }
  const discountItem = getBestTrackDiscount(state, track.id)
  const discountValue = discountItem ? discountItem.value : 0
  const price = TRACK_PRICE
  const discounted_price = price - discountValue
  return {
    ...track,
    discounted_price,
    price,
  }
}
